import styled, { css } from 'styled-components';

export enum AlertComponentType {
  danger = 0,
  warning = 1
}

const alertStyles = {
  [AlertComponentType.danger]: css`
    border: solid 2px #dc3545;
    background-color: #f8d7da;
    color: ${({ theme }) => theme.colors.grayDark4};
  `,
  [AlertComponentType.warning]: css`
    border: solid 2px #ffc107;
    background-color: #fff3cd;
    color: ${({ theme }) => theme.colors.grayDark4};
  `
};

export const AlertContainer = styled.div<{ alertType: AlertComponentType }>`
  padding: 0.75rem 1rem;
  width: fit-content;
  display: flex;
  gap: 0.75rem;
  border-radius: 4px;
  ${({ alertType }) => alertStyles[alertType]}
`;

// export const AlertContainer = styled.div<{ alertType: AlertComponentType }>`
//   padding: 0.75rem 1rem;
//   width: fit-content;

//   display: flex;
//   gap: 0.75rem;

//   border-radius: 4px;
//   border: solid 2px #ff7703;

//   background-color: #ffffe6;
//   color: ${({ theme }) => theme.colors.grayDark4};
// `;
